export default __webpack_public_path__ + "static/nasscom_thumb-da114413a0166b1fcb237ede974b13e2.png";